import { Navigate, useParams } from "react-router-dom";
import AdviserFeeStructures from "./AdviserFeeStructures";

export function LegacyClientAgreementRedirect() {
  const { adviserKey } = useParams();
  return <Navigate replace to={`/advisers/${encodeURIComponent(adviserKey)}?tab=clientAgreement`} />;
}

export default function ClientAgreement({ adviserKey, adviserId }) {
  return <div className="smFeed"><AdviserFeeStructures adviserId={adviserId} adviserKey={adviserKey} /></div>;
}